// extracted by mini-css-extract-plugin
module.exports = {"link":"link_link__jP52i","is-full-width":"link_is-full-width___RhFm","phAnimation":"link_phAnimation__wE867"};